// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__1y6Tj","question":"Question_question__2BZyp","description":"Question_description__3F-3y"};